<template>
    <div :style="modalStyle">
        <div class="modal fade" :class="[{show: opened}, cssClass]" :style="displayStyle">
            <div class="modal-dialog">
                <div class="modal-content">
                    <component :is="modalContent" v-bind="props" @dismissModal="close"/>
                </div>
            </div>
        </div>
        <div class="modal-backdrop fade" :class="{show: opened}" :style="displayStyle"/>
    </div>
</template>

<script>
    import {Event} from '../../utils'

    const ESCAPE_KEY = 27;

    export default {
        props: {
            eventName: {type: String, required: true},
        },
        data() {
            return {
                modalContent: null,
                props: null,
                cssClass: null,
                opened: false,
                zIndex: null
            }
        },
        computed: {
            displayStyle() {
                return {
                    display: this.opened ? 'block' : 'none'
                }
            },
            modalStyle() {
                return this.zIndex ? {'z-index': this.zIndex} : {};
            }
        },
        created() {
            Event.EventBus.$on(this.eventName, this.open);
        },
        methods: {
            open({component, props = null, cssClass = null, zIndex = null}) {
                document.addEventListener('keyup', this.handleKeyUp);
                this.modalContent = component;
                this.props = props;
                this.cssClass = cssClass;
                this.zIndex = zIndex;
                this.opened = true;
            },
            close() {
                document.removeEventListener('keyup', this.handleKeyUp);
                this.modalContent = null;
                this.props = null;
                this.cssClass = null;
                this.zIndex = null;
                this.opened = false;
            },
            handleKeyUp(e) {
                if (e.keyCode === ESCAPE_KEY) {
                    this.close();
                }
            }
        }
    };
</script>

<style scoped lang="scss">
    .modal__phototaking {
        opacity: 0;
        visibility: hidden;
        position: fixed;
        display: flex !important;
        justify-content: center;
        align-content: center;
        align-items: center;
        max-height: 100vh;
        overflow: hidden;
    }

    .show.modal__phototaking {
        opacity: 1;
        visibility: visible;

        .modal-dialog {
            max-width: 100%;
            max-height: 100%;
            width: auto;
            height: 100%;
            margin: 0;
        }

        .modal-content {
            max-width: 100%;
            max-height: 100%;
            width: auto;
            height: 100%;
            background: transparent;

            > div {
                /*display: flex;*/
                display: contents;
            }

            .modal-body {
                position: relative;
                max-height: 100%;
                padding: 0;
                width: auto;
                height: 100%;
            }
        }
    }
</style>
